import React from 'react';
import { FiX } from 'react-icons/fi';
import './VaultActiveFilterChips.css';

const VaultActiveFilterChips = ({ chips = [], onRemove, onClearAll }) => {
    if (!chips.length) return null;

    return (
        <div className="msv-browse-active-filters">
            {chips.map((chip) => (
                <button
                    key={chip.key}
                    type="button"
                    className="msv-browse-active-chip"
                    onClick={() => onRemove?.(chip.key)}
                >
                    {chip.label}
                    <FiX aria-hidden />
                </button>
            ))}
            <button type="button" className="msv-browse-clear-link" onClick={onClearAll}>
                Clear all
            </button>
        </div>
    );
};

export default VaultActiveFilterChips;
